import { Fragment } from "react/jsx-runtime";
import { ARRNumberProps } from "../../Utils/Types";
import { Controller } from "react-hook-form";
import { Vocabulary } from "../../Utils/Vocabulary";
import { TextField } from "@mui/material";

export default function ARRNumber(props: ARRNumberProps) {
  const { control } = props;
  return (
    <Fragment>
      <Controller
        name="ARRNumber"
        control={control}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <TextField
            {...field}
            value={field?.value || ""}
            label={Vocabulary.ARRNr}
            id="ARRNumber"
            fullWidth
            variant="outlined"
            error={!!error}
            helperText={error?.message}
            autoComplete="off"
          />
        )}
      />
    </Fragment>
  );
}
